import { ViewModel,View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { IntegerView } from "./integer-view"
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class IntegerViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new IntegerView();
    }
    public getTypeId(): string {
        return "VM-648C0F60-43F0-4236-A61F-D3251F6267C7"
    }
    public set value(v: number) { this._value = Math.trunc(getAsNumber(v,true)); } public get value(): number { return this._value;} private _value: number;

    setDefaultValue(defaultValue: any): void {
        this.value = defaultValue;
    }
    getDefaultValue():any {
        return this.value;
    }
    verify(owningClass : IMemberContainer): string[] {
        let result = [];
        return result;
    }

}
